<ng-container *ngIf="formPrincipal">
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">{{ modelRecived ? 'Editar Bonificación' : 'Agregar Bonificación' }}</h2>
    </div>
    <div class="search-section">
      <div class="button-section">
        <button class="btn-new" mat-raised-button color="accent" appPermissionControl="P134B0002" (click)="modelRecived ? update(form.value) : create(form.value)">
          <mat-icon>save</mat-icon>
          {{ modelRecived ? 'Actualizar' : 'Guardar' }}
        </button>
        <button class="btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P134B0001"><mat-icon>arrow_back</mat-icon>Cancelar</button>
      </div>
    </div>
  </div>

  <form class="mt-5" [formGroup]="form" (submit)="modelRecived ? update(form.value) : create(form.value)" appPermissionControl="P134F0001">
    <div class="form-row">
      <!-- Variable -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Variable Id</label>
        <input id="numVar" class="form-control" formControlName="numVar" type="number" [readonly]="modelRecived" required appPermissionControl="P134K0001" />
      </div>

      <!-- Descripcion -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Descripción</label>
        <input class="form-control" formControlName="descripcion" type="text" required appPermissionControl="P134K0002" />
      </div>

      <!-- Concepto -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Concepto</label>
        <select class="form-control" formControlName="concepto" required appPermissionControl="P134K0003">
          <option value>-- Seleccione --</option>
          <option *ngFor="let concepto of conceptos" [value]="concepto.concepto">{{ concepto.concepto }} | {{ concepto.descripcion }}</option>
        </select>
      </div>

      <!-- Días de -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Días de</label>
        <input class="form-control" formControlName="amortInf" type="number" readonly appPermissionControl="P134K0004" />
      </div>

      <!-- Días a -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Días a</label>
        <input class="form-control" formControlName="amortSup" type="number" required appPermissionControl="P134K0005" />
      </div>

      <!-- Porcentaje -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Porcentaje</label>
        <select class="form-control" formControlName="claveTasa" required appPermissionControl="P134K0006">
          <option value>-- Seleccione --</option>
          <option *ngFor="let tasa of tasas" [value]="tasa.clave">{{ tasa.clave }} | {{ tasa.descripcion }}</option>
        </select>
      </div>
    </div>
  </form>
</ng-container>
